"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayFromRange = arrayFromRange;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

/**
 * A convenience method for creating an array of numbers from "from" to "to"
 * @param {Number} from A number that starts the range
 * @param {Number} to A number that ends the range
 */
function arrayFromRange(from, to) {
  return (0, _toConsumableArray2.default)(Array(Math.abs(from - to) + 1)).map(function (_, n) {
    return from + n * (from > to ? -1 : 1);
  });
}